import type { Region } from '@/types/domain/core';
import { coreRequestService } from '@/api/core';

export const regionGet = () => coreRequestService<Region>({
    url: '/region',
    method: 'GET'
});
